import React, { useEffect, useState } from "react";
import { AdminViewSingleOrder, updateOrder } from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { OrderDetailState } from "../Services/RecoilAtoms";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

const OrderDetails = () => {
  const [date, setDate] = useState(new Date());
  const [productData, setProductData] = useState([]);
  const [orderData, setOrderData] = useState({});

  const VieworderDetail = useRecoilValue(OrderDetailState);

  const params = useParams();

  //   fetching orders
  const fetchingOrders = async () => {
    try {
      const response = await AdminViewSingleOrder(params.orderId);
      setOrderData(response?.data);
      console.log(response?.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  useEffect(() => {
    fetchingOrders();
  }, []);

  const handleOrderUpdate = async (orderId, status) => {
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this order?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      });
  
      if (confirmResult.isConfirmed) {
        const response = await updateOrder(orderId, {status: status});

        Swal.fire({
          icon: "success",
          title: "Order Updated!",
          text: "The order details have been successfully updated.",
        });
  
        // Refresh the order data (assuming a fetchOrders function exists)
        fetchingOrders();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.message,
      });
    }
  };
  
  

  return (
    <>
      <section class="content-main">
        <div class="content-header">
          <div>
            <h2 class="content-title card-title">Order detail</h2>
            <p>Details for Order ID: {orderData?.orderId}</p>
          </div>
        </div>
        <div class="card">
          <header class="card-header">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 mb-lg-0 mb-15">
                <span>
                  <i class="material-icons md-calendar_today"></i>{" "}
                  <b>
                    {new Date(orderData?.createdDate).toDateString()},{" "}
                    {new Date(orderData?.createdDate).toLocaleTimeString()}
                  </b>
                </span>
                <br />
                <small class="text-muted">Order ID: {orderData?.orderId}</small>
              </div>
              <div class="col-lg-6 col-md-6 ms-auto text-md-end">
                {/* <select class="form-select d-inline-block mb-lg-0 mr-5 mw-200">
                  <option>Change status</option>
                  <option>Awaiting payment</option>
                  <option>Confirmed</option>
                  <option>Shipped</option>
                  <option>Delivered</option>
                </select>
                <a class="btn btn-primary" href="#">
                  Save
                </a>
                <a class="btn btn-secondary print ms-2" href="#">
                  <i class="icon material-icons md-print"></i>
                </a> */}
              </div>
            </div>
          </header>

          <div class="card-body">
            <div class="row mb-50 mt-20 order-info-wrap">
              <div class="col-md-4">
                <article class="icontext align-items-start">
                  <span class="icon icon-sm rounded-circle bg-primary-light">
                    <i class="text-primary material-icons md-person"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1">Customer</h6>
                    <p class="mb-1">
                      {orderData?.customerName} <br />
                      {orderData?.customerEmail}
                      <br />
                      Shipping Type:{" "}
                      {orderData?.shippingType === 0 ? "Pickup" : "Delivery"}
                      {/* +998 99 22123456 */}
                    </p>
                    {/* <a href="#">View profile</a> */}
                  </div>
                </article>
              </div>

              <div class="col-md-4">
                <article class="icontext align-items-start">
                  <span class="icon icon-sm rounded-circle bg-primary-light">
                    <i class="text-primary material-icons md-local_shipping"></i>
                  </span>
                  <div className="text">
                    <h6 className="mb-1">Order info</h6>
                    <p className="mb-1">
                      Shipping: ChamsAccess Bike <br />
                      Pay method: {orderData?.paymentMethod}
                      <br />
                      Status:
                      <select
                        value={orderData?.status}
                        onChange={(e) =>
                          handleOrderUpdate(orderData?.orderId, e.target.value)
                        }
                        className="form-select d-inline-block w-auto ms-2"
                      >
                        <option value="pending">Pending</option>
                        <option value="shipped">Shipped</option>
                        <option value="delivered">Delivered</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </p>
                  </div>
                </article>
              </div>

              <div class="col-md-4">
                <article class="icontext align-items-start">
                  <span class="icon icon-sm rounded-circle bg-primary-light">
                    <i class="text-primary material-icons md-place"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1">Deliver to</h6>
                    <p class="mb-1">
                      City: {orderData?.deliveryDetails?.city}
                      <br />
                      Address: {orderData?.deliveryDetails?.address} <br />
                      Phone: {orderData?.deliveryDetails?.phone}
                    </p>
                    {/* <a href="#">View profile</a> */}
                  </div>
                </article>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-7">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th width="40%">Image</th>
                        <th width="40%">Product</th>
                        <th width="20%">Unit Price</th>
                        <th width="20%">Quantity</th>
                        <th width="20%" class="text-end">
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* <tr>
                        <td>
                          <img
                            style={{ width: "40px", height: "30px" }}
                            //   src={`http://localhost:7045/uploads/${props["product_data"]?.productImages[0].img}`}
                            //   src={`https://backend.argone.ng/uploads/${props["product_data"]?.productImages[0].img}`}
                            alt="#"
                          />
                        </td>
                        <td>Haagen-Dazs Caramel Cone Ice</td>
                        <td>$44.25</td>
                        <td>2</td>
                        <td class="text-end">$99.50</td>
                      </tr> */}

                      {orderData?.orderItems?.map((item, i) => (
                        <tr key={"order" + i}>
                          <td>
                            <img
                              // style={{ width: "40px", height: "30px" }}
                              // src={`http://localhost:7045/uploads/${orderData["product_data"]?.productImages[0].img}`}
                              src={`https://backend.argone.ng/uploads/${item?.image}`}
                              alt="#"
                            />
                          </td>
                          <td>{item?.productName}</td>
                          <td>₦{item?.unitPrice?.toLocaleString()}</td>
                          <td>{item?.quantity}</td>
                          <td class="text-end">
                            ₦{item?.totalPrice?.toLocaleString()}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4">
                          <article class="float-end">
                            {/* <dl class="dlist">
                              <dt>Subtotal:</dt>
                              <dd>$973.35</dd>
                            </dl>
                            <dl class="dlist">
                              <dt>Shipping cost:</dt>
                              <dd>$10.00</dd>
                            </dl> */}
                            <dl class="dlist">
                              <dt>Grand total:</dt>
                              <dd>
                                <b class="h5">
                                  ₦{orderData?.amount?.toLocaleString()}
                                </b>
                              </dd>
                            </dl>
                            <dl class="dlist">
                              <dt class="text-muted">Status:</dt>
                              <dd>
                                <span
                                  class={`badge rounded-pill ${
                                    orderData?.status === "success"
                                      ? "alert-success text-success"
                                      : "alert-secondary text-secondary"
                                  }`}
                                >
                                  {orderData?.status}
                                </span>
                              </dd>
                            </dl>
                          </article>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-lg-1"></div>
              {/* <div class='col-lg-4'>
								<div class='box shadow-sm bg-light'>
									<h6 class='mb-15'>Payment info</h6>
									<p>
										<img
											src='assets/imgs/card-brands/2.png'
											class='border'
											height='20'
										/>{" "}
										Master Card **** **** 4768 <br />
										Business name: Grand Market LLC <br />
										Phone: +1 (800) 555-154-52
									</p>
								</div>
								<div class='h-25 pt-4'>
									<div class='mb-3'>
										<label>Notes</label>
										<textarea
											class='form-control'
											name='notes'
											id='notes'
											placeholder='Type some note'></textarea>
									</div>
									<button class='btn btn-primary'>Save note</button>
								</div>
							</div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OrderDetails;

const toProperCase = (text) => {
  return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};
